// import React, { useEffect, useRef, useState } from "react";
// import { MdKeyboardArrowRight } from "react-icons/md";
// import { BiHomeAlt } from "react-icons/bi";
// import "../AddEmployee/AddEmployee.css";
// import Select from "react-select";
// import { Apiurl, GetToken, Token, userId } from "../../../Utils/utils";
// import axios from "axios";
// import { toast } from "react-toastify";
// import FloatingLabelInput from "../../../Components/floatingLabel/FloatingLabel";
// import Header from "../../../Components/Dashboard/Header/Header";
// import Sidebar from "../../../Components/Dashboard/Sidebar/Sidebar";
// import { useLocation } from "react-router-dom";
// import moment from "moment";
// import Loader from "../../../Components/loader/loader";

// const AddEmployee = () => {
//   const [loading, setLoading] = useState(false);
//   const location = useLocation();
//   const comingData = location.state;
//   const [addEmloyee, setAddEmloyee] = useState({
//     Name: "",
//     LastName:"",
//     Address: "",
//     Email: "",
//     Phone: "",
//     EmergencyContact: "",
//     Gender: "",
//     DateOfBirth: "",
//     DateOfJoining: "",
//     DateOfLeaving: "",
//     Department: "",
//     Designation: "",
//     TeamLead: "",
//     UserRole: "",
//     UploardImage: "",
//     Password: "",
//     ImageExtension: "",
//     ImageName: "",
//   });
//   const [departmentData, setDepartmentData] = useState([]);
//   const [saveDesignationOfDepartment, setSaveDesignationOfDepartment] =
//     useState("");
//   const [teamLeadData, setTeamLeadData] = useState([]);
//   const [isFinalTeamLeadData, setIsFinalTeamLeadData] = useState("");
//   const [DesignationData, setDesignationData] = useState([]);
//   const [userRoleData, setUserRoleData] = useState([]);
//   const currentDate = new Date().toISOString().split("T")[0];
//   const [showSidebar, setShowSidebar] = useState(true);
//   const fileInputRef = useRef(null);
//   const [departmentId, setDepartmentId] = useState("");
//   const [designationId, setDesignationId] = useState("");
//   const handleDepartmentChange = (selectedOption) => {
//     setDepartmentId(selectedOption?.value);
//     setAddEmloyee({ ...addEmloyee, Department: selectedOption });
//   };
//   const handleDesignationData = (selectedOption) => {
//     setAddEmloyee({ ...addEmloyee, Designation: selectedOption });
//     setSaveDesignationOfDepartment(selectedOption);
//     setDesignationId(selectedOption?.Id);
//   };
//   const [finalUserRole, setFinalUserRole] = useState();
//   const [userRoleError, setUserRoleError] = useState();
//   const handleTeamLeadData = (e) => {
//     setIsFinalTeamLeadData(e);
//     setAddEmloyee({ ...addEmloyee, TeamLead: e });
//   };
//   const handleUserRole = (e) => {
//     setFinalUserRole(e);
//     setAddEmloyee({ ...addEmloyee, UserRole: e ,Department:"" });
//     setDesignationData([])

//   };
//   const DateOfBirth = (e) => {
//     const selectedDate = e.target.value;
//     const today = new Date();
//     const birthDate = new Date(selectedDate);
//     const age = today.getFullYear() - birthDate.getFullYear();
//     const monthDiff = today.getMonth() - birthDate.getMonth();
//     if (
//       age < 18 ||
//       (age === 18 &&
//         (monthDiff > 0 ||
//           (monthDiff === 0 && today.getDate() < birthDate.getDate())))
//     ) {
//       setAddEmloyee({
//         ...addEmloyee,
//         DateOfBirth: "",
//       });
//     } else {
//       setAddEmloyee({
//         ...addEmloyee,
//         DateOfBirth: selectedDate,
//       });
//     }
//   };

//   const handleFileChange = (event) => {
//     const file = event.target.files[0];
//     if (file) {
//       const reader = new FileReader();
//       reader.onloadend = () => {
//         const base64Image = reader.result;
//         const exactBase64 = base64Image.split(",")[1];
//         const fileExtension = file.name.split(".").pop().toLowerCase();

//         setAddEmloyee({
//           ...addEmloyee,
//           UploardImage: exactBase64,
//           ImageExtension: fileExtension,
//           ImageName: file,
//         });
//       };
//       reader.readAsDataURL(file);
//     }
//   };
//   useEffect(() => {
//     if (window.innerWidth < 600) {
//       const timeoutId = setTimeout(() => {
//         setShowSidebar(false);
//       }, 1000);
//       return () => clearTimeout(timeoutId);
//     }
//     setShowSidebar(true);
//   }, [])
//   const Gender = [
//     { value: "Male", label: "Male", id: 0 },
//     { value: "Female", label: "Female", id: 1 },
//     // { value: "Transgender", label: "Transgender", id: 2 },
//   ];
//   const ComingEditDob = moment(comingData?.DateOfBirth).format("YYYY-MM-DD");

//   const ComingEditDateOfJoining = moment(comingData?.DateOfJoining).format(
//     "YYYY-MM-DD"
//   );
//   const ComingEditDateOfLeaving = moment(comingData?.DateOfLeaving).format(
//     "YYYY-MM-DD"
//   );
//   const ComingGender = Gender?.filter((i) => i?.id === comingData?.Gender);

//   const ComingDepartment = departmentData?.filter(
//     (e) => e?.value === comingData?.Department
//   );
//   const ComingDesignation = DesignationData?.filter(
//     (e) => e?.value === comingData?.Department
//   );
//   const SUBDesignation = DesignationData?.filter(
//     (e) => e.Id === comingData?.DesignationName
//   );

//   useEffect(() => {
//     if (comingData) {
//       setAddEmloyee({
//         Name: comingData?.FirstName,
//         LastName:comingData?.LastName,
//         Email: comingData?.Email,
//         Address: comingData?.Address,
//         Phone: comingData?.Mobile,
//         EmergencyContact: comingData?.Emergencycontactno,
//         Gender: ComingGender,
//         DateOfBirth: ComingEditDob,
//         DateOfJoining: ComingEditDateOfJoining,
//         DateOfLeaving: ComingEditDateOfLeaving,
//         Department: ComingDepartment,
//         Designation: ComingDesignation,
//         DesignationName: SUBDesignation,
//       });
//     }
//   }, [comingData]);

//   const [errorName, setErrorName] = useState(false);
//   const [errorLastName, setErrorLastName] = useState(false);
//   const [errorAddress, setErrorAddress] = useState(false);
//   const [errorEmail, setErrorEmail] = useState(false);
//   const [errorPhone, setErrorPhone] = useState(false);
//   const [errorEmergencyContact, setErrorEmergencyContact] = useState(false);
//   const [errorDateOfBirth, setErrorDateOfBirth] = useState(false);
//   const [errorDateOfJoining, setErrorDateOfJoining] = useState(false);
//   const [errorDateofLeaving, setErrorDateOfLeaving] = useState(false);
//   const [errorGender, setErrorGender] = useState(false);
//   const [departmentError, setDepartmentError] = useState(false);
//   const [designationDepartmentError, setDesignationDepartmentError] =
//     useState(false);
//   const [teamLeadDepartMentError, setTeamLeadDepartMentError] = useState(false);
//   const [uploadImageError, setUploadImageError] = useState(false);
//   const [errorPassword, setErrorPassword] = useState(false);
//   const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
//   function isValidEmail(Email) {
//     return emailRegex.test(Email);
//   }

//   const validate = () => {
//     if (!addEmloyee?.Name) {
//       setErrorName("usernamedata");
//       return false;
//     }
//     if (!addEmloyee?.LastName) {
//       setErrorLastName("userLastnamedata");
//       return false;
//     }

//     if (!addEmloyee?.Email) {
//       setErrorEmail("userEmail");
//       return false;
//     }

//     if (!isValidEmail(addEmloyee?.Email)) {
//       toast.error("Please enter valid email");
//       return false;
//     }
//     if (!addEmloyee?.Address) {
//       setErrorAddress("userAddress");
//       return false;
//     }

//     if (!addEmloyee?.Phone) {
//       setErrorPhone("userPhone");
//       return false;
//     }
//     if (addEmloyee?.Phone?.length < 10) {
//       toast.error("Please enter correct number");
//       return false;
//     }

//     if (!addEmloyee?.EmergencyContact) {
//       setErrorEmergencyContact("userEmergencyContact");
//       return false;
//     }
//     if (addEmloyee?.EmergencyContact?.length < 10) {
//       toast.error("Please enter correct number");
//       return false;
//     }
//     if (!addEmloyee?.Password) {
//       setErrorPassword("password");
//       return false;
//     }

//     if (!addEmloyee?.DateOfBirth) {
//       setErrorDateOfBirth("userDateOfBirth");
//       return false;
//     }
//     if (!addEmloyee?.DateOfJoining) {
//       setErrorDateOfJoining("userDateOfJoining");
//       return false;
//     }
//     // if (!addEmloyee?.DateOfLeaving) {
//     //   setErrorDateOfLeaving("userDateofLeaving");
//     //   return false;
//     // }
//     if (!addEmloyee?.Gender) {
//       setErrorGender("userGender");
//       return false;
//     }
//     if (!finalUserRole) {
//       setUserRoleError("userRole");
//       return false;
//     }

//     if (!departmentId) {
//       setDepartmentError("department");
//       return false;
//     }
//     if (!designationId) {
//       setDesignationDepartmentError("userDepartmentDesignation");
//       return false;
//     }
//     if (teamLeadData?.length && !isFinalTeamLeadData) {
//       setTeamLeadDepartMentError("userDepartmentTeamLead");
//       return false;
//     }
//     if (!addEmloyee?.UploardImage) {
//       setUploadImageError("useruploadImage");
//       return false;
//     }
//     return true;
//   };

//   //  SaveEmployee Api
//   const handleAddEmployee = (e) => {
//     if (!validate()) return;
//     e?.preventDefault();
//     setLoading(true);
//     const LoginToken = GetToken();
//     const data = {};

//     if (comingData) {
//       data.Id = comingData.Id
//       data.FirstName = addEmloyee?.Name;
//       data.LastName = addEmloyee?.LastName;
//       data.Designation = designationId;
//       data.Address = addEmloyee?.Address;
//       data.Email = addEmloyee?.Email;
//       data.Mobile = addEmloyee?.Phone;
//       data.Emergencycontactno = addEmloyee?.EmergencyContact;
//       data.DateOfBirth = addEmloyee?.DateOfBirth;
//       data.DateOfJoining = addEmloyee?.DateOfJoining;
//       data.DateofLeaving = addEmloyee?.DateOfLeaving;
//       data.Department = departmentId;
//       data.Photo = addEmloyee?.UploardImage;
//       data.Gender = addEmloyee?.Gender?.id;
//       data.Position = addEmloyee?.UserRole?.Id;
//       data.TeamLead = addEmloyee?.TeamLead?.userId;
//       data.Password = addEmloyee?.Password;
//       data.PhotoExtenssion = addEmloyee?.ImageExtension;
//     }else{
//       data.FirstName = addEmloyee?.Name;
//       data.LastName = addEmloyee?.LastName;
//       data.Designation = designationId;
//       data.Address = addEmloyee?.Address;
//       data.Email = addEmloyee?.Email;
//       data.Mobile = addEmloyee?.Phone;
//       data.Emergencycontactno = addEmloyee?.EmergencyContact;
//       data.DateOfBirth = addEmloyee?.DateOfBirth;
//       data.DateOfJoining = addEmloyee?.DateOfJoining;
//       data.DateofLeaving = addEmloyee?.DateOfLeaving;
//       data.Department = departmentId;
//       data.Photo = addEmloyee?.UploardImage;
//       data.Gender = addEmloyee?.Gender?.id;
//       data.Position = addEmloyee?.UserRole?.Id;
//       data.TeamLead = addEmloyee?.TeamLead?.userId;
//       data.Password = addEmloyee?.Password;
//       data.PhotoExtenssion = addEmloyee?.ImageExtension;
//     }
//     const option = {
//       method: "POST",
//       headers: {
//         "access-control-allow-origin": "*",
//         "content-type": "application/json",
//         authorization: `Bearer ${LoginToken}`,
//       },
//       url: `${Apiurl()}/Admin/SaveEmployee`,
//       data: { data: JSON.stringify(data) },
//     };
//     axios(option)
//       .then((e) => {
//         setLoading(false);
//         if (e?.status === 200) {
//           toast.success(e?.data?.message);
//           setAddEmloyee({
//             Name: "",
//             LastName:"",
//             Address: "",
//             Email: "",
//             Phone: "",
//             EmergencyContact: "",
//             Gender: "",
//             DateOfBirth: "",
//             DateOfJoining: "",
//             DateOfLeaving: "",
//             Department: "",
//             Designation: "",
//             TeamLead: "",
//             UserRole: "",
//             UploardImage: "",
//             Password: "",
//             ImageExtension: "",
//           });
//           setDepartmentId("")
//           setErrorName("")
//           setErrorLastName("")
//           setErrorEmail("")
//           setErrorAddress("")
//           setErrorPhone("")
//           setErrorEmergencyContact("")
//           setErrorPassword("")
//           setErrorDateOfBirth("")
//           setErrorDateOfBirth("")
//           setErrorDateOfJoining("")
//           setErrorDateOfLeaving("")
//           setErrorGender("")
//           setUserRoleError("")
//           setUploadImageError("")
//           setDepartmentError("")
//           setDesignationDepartmentError("")
//           setTeamLeadDepartMentError("")
//           fileInputRef.current.value = null;
//         }
//       })

//       .catch((err) => {
//         setLoading(false);
//         toast.error(err?.response?.data?.message);
//       });
//   };

//   // Get Departments API
//   const getDepartment = () => {
//     setLoading(true);
//     const token = GetToken();
//     const option = {
//       method: "GET",
//       headers: {
//         "access-control-allow-origin": "*",
//         "content-type": "application/json",
//         Authorization: `Bearer ${token}`,
//       },
//       url: `${Apiurl()}/Admin/GetDepartments`,
//     };
//     axios(option)
//       .then((e) => {
//         setLoading(false);
//         const data = JSON.parse(e?.data?.data);
//         const finalData = data?.map((item) => ({
//           label: item?.Name,
//           value: item?.Id,
//         }));
//         setDepartmentData(finalData);
//       })
//       .catch((err) => {
//         setLoading(false);
//       });
//   };

//   useEffect(() => {
//     getDepartment();
//   }, []);

//   // Post GetDesignations api
//   const handleDesignations = (e) => {
//     if (!validate()) return;
//     e?.preventDefault();
//     setLoading(true);
//     const LoginToken = GetToken();

//     const data = {};
//     data.DepartmentId = departmentId;

//     const option = {
//       method: "POST",
//       headers: {
//         "access-control-allow-origin": "*",
//         "content-type": "application/json",
//         authorization: `Bearer ${LoginToken}`,
//       },
//       url: `${Apiurl()}/Admin/GetDesignations`,
//       data: { data: JSON.stringify(data) },
//     };
//     axios(option)
//       .then((e) => {
//         setLoading(false);
//         const data = JSON.parse(e?.data?.data);
//         setDesignationData(data);
//       })
//       .catch((err) => {
//         setLoading(false);
//         toast.error(err?.response?.data?.message);
//       });
//   };
//   useEffect(() => {
//     if (departmentId) {
//       setSaveDesignationOfDepartment("");
//       setDesignationId("");
//       setTeamLeadData("");
//       setAddEmloyee({ ...addEmloyee, Designation: "", TeamLead: "" });
//       setIsFinalTeamLeadData("");
//       handleDesignations();
//     }
//   }, [departmentId]);
//   // team leads retrieve
//   const GetTeamLeads = () => {
//     setLoading(true);
//     const LoginToken = GetToken();
//     const data = {};
//     data.Department = saveDesignationOfDepartment?.DepartmentId;
//     data.Designation = saveDesignationOfDepartment?.Id;

//     const option = {
//       method: "POST",
//       headers: {
//         "access-control-allow-origin": "*",
//         "content-type": "application/json",
//         authorization: `Bearer ${LoginToken}`,
//       },
//       url: `${Apiurl()}/Admin/GetTeamleads`,
//       data: { data: JSON.stringify(data) },
//     };
//     axios(option)
//       .then((e) => {
//         setLoading(false);
//         const data = JSON.parse(e?.data?.data);
//         setTeamLeadData(data);
//       })
//       .catch((err) => {
//         setLoading(false);
//       });
//   };

//   useEffect(() => {
//     if (saveDesignationOfDepartment) {
//       setAddEmloyee({ ...addEmloyee, TeamLead: "" });
//       setIsFinalTeamLeadData("");
//       GetTeamLeads();
//     }
//   }, [saveDesignationOfDepartment]);

//   // user role retrieve
//   const GetUserRole = () => {
//     setLoading(true);
//     const LoginToken = GetToken();
//     const option = {
//       method: "GET",
//       headers: {
//         "access-control-allow-origin": "*",
//         "content-type": "application/json",
//         authorization: `Bearer ${LoginToken}`,
//       },
//       url: `${Apiurl()}/Admin/GetPositions`,
//     };
//     axios(option)
//       .then((e) => {
//         setLoading(false);
//         const data = JSON.parse(e?.data?.data);
//         setUserRoleData(data);
//       })
//       .catch((err) => {
//         setLoading(false);
//       });
//   };

//   useEffect(() => {
//     GetUserRole();
//   }, []);

//   useEffect(() => {
//     // Check if UserRole is HR and set default department
//     if (addEmloyee?.UserRole?.RoleName === "HR") {
//       const defaultDepartment = departmentData.find(
//         (department) => department.label === "Management"
//       );
//       handleDepartmentChange(defaultDepartment);
//     }
//   }, [addEmloyee?.UserRole]);

//  const handleEmptyInputData = () => {
//     setAddEmloyee((prevEmployee) => ({
//       ...prevEmployee,
//       Name: "",
//       LastName:"",
//       Address: "",
//       Email: "",
//       Phone: "",
//       EmergencyContact: "",
//       Gender: "",
//       DateOfBirth: "",
//       DateOfJoining: "",
//       DateOfLeaving: "",
//       Department: "",
//       Designation: "",
//       TeamLead: "",
//       UserRole: "",
//       UploardImage: "",
//       Password: "",
//       ImageExtension: "",
//       ImageName: "",
//     }));
//     setDepartmentId("")
//     setErrorName("")
//     setErrorLastName("")
//     setErrorEmail("")
//     setErrorAddress("")
//     setErrorPhone("")
//     setErrorEmergencyContact("")
//     setErrorPassword("")
//     setErrorDateOfBirth("")
//     setErrorDateOfBirth("")
//     setErrorDateOfJoining("")
//     setErrorDateOfLeaving("")
//     setErrorGender("")
//     setUserRoleError("")
//     setUploadImageError("")
//     setDepartmentError("")
//     setDesignationDepartmentError("")
//     setTeamLeadDepartMentError("")
//     fileInputRef.current.value = null;
//   };

//   return (
//     <>
//       {loading ? <Loader /> : null}
//       <Header showSidebar={showSidebar} setShowSidebar={setShowSidebar} />
//       <div className="d-flex">
//         <Sidebar showSidebar={showSidebar} />
//         <section className={ showSidebar
//         ?"addEmloyees-section"
//         :"addEmloyees-section-new"
//       }>
//           <div className="addEmloyees-all-icons">
//             <div>
//               <p className="DASHBOARD-MAIN-HEADING">Add Employee </p>
//             </div>
//             <div className="dashboiard-inner-header">
//               <BiHomeAlt className="home-icon-header-inn" />
//               <MdKeyboardArrowRight />
//               <p>Employees </p>
//               <MdKeyboardArrowRight />
//               <p>Add Employee </p>
//             </div>
//           </div>

//           <div className="Addemployee-main-container">
//             <div className="Addemployee-outter-container">
//               <div className="Addemployee-inner-container">
//                 <div className="AddEmployee-heading">
//                   <p>Add Employee</p>
//                 </div>
//                 <div className="Addemployee-inner-box row">
//                   <div className="Addemployee-inputs col-md-6">
//                     <FloatingLabelInput
//                       label="First Name*"
//                       value={addEmloyee?.Name}
//                       onChange={(e) =>
//                         setAddEmloyee({
//                           ...addEmloyee,
//                           Name: e?.target?.value,
//                         })
//                       }
//                       onBlur={(e) => {
//                         if (!e?.target?.value) {
//                           setErrorName("usernamedata");
//                         } else {
//                           setErrorName("false");
//                         }
//                       }}
//                     />
//                     {errorName === "usernamedata" && !addEmloyee?.Name ? (
//                       <span className="contact_error-Addemployee">
//                         First Name is required.
//                       </span>
//                     ) : null}
//                   </div>

//                   <div className="Addemployee-inputs col-md-6">
//                     <FloatingLabelInput
//                       label="Last Name*"
//                       value={addEmloyee?.LastName}
//                       onChange={(e) =>
//                         setAddEmloyee({
//                           ...addEmloyee,
//                           LastName: e?.target?.value,
//                         })
//                       }
//                       onBlur={(e) => {
//                         if (!e?.target?.value) {
//                           setErrorLastName("userLastnamedata");
//                         } else {
//                           setErrorLastName("false");
//                         }
//                       }}
//                     />
//                     {errorLastName === "userLastnamedata" && !addEmloyee?.LastName ? (
//                       <span className="contact_error-Addemployee">
//                         Last Name is required.
//                       </span>
//                     ) : null}
//                   </div>

//                   <div className="Addemployee-inputs col-md-6">
//                     <FloatingLabelInput
//                       label="Email*"
//                       value={addEmloyee?.Email}
//                       onChange={(e) =>
//                         setAddEmloyee({
//                           ...addEmloyee,
//                           Email: e?.target?.value,
//                         })
//                       }
//                       onBlur={(e) => {
//                         if (!e?.target?.value) {
//                           setErrorEmail("userEmail");
//                         } else {
//                           setErrorEmail("false");
//                         }
//                       }}
//                     />
//                     {errorEmail === "userEmail" && !addEmloyee?.Email ? (
//                       <span className="contact_error-Addemployee">
//                         Email is required.
//                       </span>
//                     ) : null}
//                   </div>
//                   <div className="Addemployee-inputs col-md-6">
//                     <FloatingLabelInput
//                       label="Address*"
//                       value={addEmloyee?.Address}
//                       onChange={(e) =>
//                         setAddEmloyee({
//                           ...addEmloyee,
//                           Address: e?.target?.value,
//                         })
//                       }
//                       onBlur={(e) => {
//                         if (!e?.target?.value) {
//                           setErrorAddress("userAddress");
//                         } else {
//                           setErrorAddress("false");
//                         }
//                       }}
//                     />
//                     {errorAddress === "userAddress" && !addEmloyee?.Address ? (
//                       <span className="contact_error-Addemployee">
//                         Address is required.
//                       </span>
//                     ) : null}
//                   </div>
//                   <div className="Addemployee-inputs col-md-4">
//                     <FloatingLabelInput
//                       type="tel"
//                       label="Phone No*"
//                       maxLength="10"
//                       value={addEmloyee?.Phone}

//                       onChange={(e) => {
//                         const inputMobile = e.target.value
//                           .replace(/\D/g, "")
//                           .slice(0, 10);
//                           setAddEmloyee({
//                           ...addEmloyee,
//                           Phone: inputMobile,
//                         });
//                       }}
//                       // onChange={(e) =>
//                       //   setAddEmloyee({
//                       //     ...addEmloyee,
//                       //     Phone: e?.target?.value,
//                       //   })
//                       // }
//                       onBlur={(e) => {
//                         if (!e?.target?.value) {
//                           setErrorPhone("userPhone");
//                         } else {
//                           setErrorPhone("false");
//                         }
//                       }}
//                     />
//                     {errorPhone === "userPhone" && !addEmloyee?.Phone ? (
//                       <span className="contact_error-Addemployee">
//                         Phone Number is required.
//                       </span>
//                     ) : null}
//                   </div>
//                   <div className="Addemployee-inputs col-md-4">
//                     <FloatingLabelInput
//                       type="tel"
//                       maxLength="10"
//                       label="Emergency Contact No.*"
//                       value={addEmloyee?.EmergencyContact}

//                       onChange={(e) => {
//                         const inputMobile = e.target.value
//                           .replace(/\D/g, "")
//                           .slice(0, 10);
//                           setAddEmloyee({
//                           ...addEmloyee,
//                           EmergencyContact: inputMobile,
//                         });
//                       }}

//                       // onChange={(e) =>
//                       //   setAddEmloyee({
//                       //     ...addEmloyee,
//                       //     EmergencyContact: e?.target?.value,
//                       //   })
//                       // }
//                       onBlur={(e) => {
//                         if (!e?.target?.value) {
//                           setErrorEmergencyContact("userEmergencyContact");
//                         } else {
//                           setErrorEmergencyContact("false");
//                         }
//                       }}
//                     />
//                     {errorEmergencyContact === "userEmergencyContact" &&
//                     !addEmloyee?.EmergencyContact ? (
//                       <span className="contact_error-Addemployee">
//                         Emergency Contact Number is required.
//                       </span>
//                     ) : null}
//                   </div>

//                   <div className="Addemployee-inputs col-md-4">
//                     <FloatingLabelInput
//                       type="password"
//                       label="Password*"
//                       value={addEmloyee?.Password}
//                       onChange={(e) =>
//                         setAddEmloyee({
//                           ...addEmloyee,
//                           Password: e?.target?.value,
//                         })
//                       }
//                       onBlur={(e) => {
//                         if (!e?.target?.value) {
//                           setErrorPassword("Password");
//                         } else {
//                           setErrorPassword("false");
//                         }
//                       }}
//                     />
//                     {errorPassword === "password" && !addEmloyee?.Password ? (
//                       <span className="contact_error-Addemployee">
//                         Password is required.
//                       </span>
//                     ) : null}
//                   </div>

//                   <div className="Addemployee-inputs-cal col-md-4   ">
//                     <label htmlFor="DateOfBirth">Date of Birth </label>
//                     <input
//                       type="date"
//                       name="DateOfBirth"
//                       id="DateOfBirth"
//                       value={addEmloyee?.DateOfBirth}
//                       onChange={DateOfBirth}
//                       max={moment().subtract(18, "years").format("YYYY-MM-DD")}
//                     />
//                     {errorDateOfBirth === "userDateOfBirth" &&
//                     !addEmloyee?.DateOfBirth ? (
//                       <span className="contact_error-dob">
//                         Date Of Birth is required.
//                       </span>
//                     ) : null}
//                   </div>
//                   <div className="Addemployee-inputs-cal col-md-4">
//                     <label htmlFor="">Date of Joining</label>
//                     <input
//                       type="date"
//                       name=""
//                       id=""
//                       value={addEmloyee?.DateOfJoining}
//                       onChange={(e) =>
//                         setAddEmloyee({
//                           ...addEmloyee,
//                           DateOfJoining: e?.target?.value,
//                         })
//                       }
//                       max={currentDate}
//                     />

//                     {errorDateOfJoining === "userDateOfJoining" &&
//                     !addEmloyee?.DateOfJoining ? (
//                       <span className="contact_error-dob">
//                         Date Of Joining is required.
//                       </span>
//                     ) : null}
//                   </div>
//                   <div className="Addemployee-inputs-cal col-md-4">
//                     <label htmlFor="">Date of Leaving</label>
//                     <input
//                       type="date"
//                       value={addEmloyee?.DateOfLeaving}
//                       onChange={(e) =>
//                         setAddEmloyee({
//                           ...addEmloyee,
//                           DateOfLeaving: e?.target?.value,
//                         })
//                       }
//                       max={currentDate}
//                     />
//                   </div>
//                   {/* {errorDateofLeaving === "userDateofLeaving" &&
//                     !addEmloyee?.DateOfLeaving ? (
//                       <span className="contact_error-dob">
//                         Date Of Joining is required.
//                       </span>
//                     ) : null} */}

//                   <div className="Addemployee-inputs-gender col-md-6">
//                     <label htmlFor="" className="label-manaegement-section">
//                       Gender
//                     </label>
//                     <Select
//                       //   className="Department-dropdown"
//                       classNamePrefix="genderSelect"
//                       placeholder="Please Select Gender"
//                       options={Gender}
//                       value={addEmloyee?.Gender}
//                       onChange={(selectedOption) =>
//                         setAddEmloyee({
//                           ...addEmloyee,
//                           Gender: selectedOption,
//                         })
//                       }
//                       onBlur={(e) => {
//                         if (!e?.target?.value) {
//                           setErrorGender("userGender");
//                         } else {
//                           setErrorGender("false");
//                         }
//                       }}
//                     />
//                     {errorGender === "userGender" && !addEmloyee?.Gender ? (
//                       <span className="contact_error-Addemployee">
//                         Gender is required.
//                       </span>
//                     ) : null}
//                   </div>

//                   <div className="Addemployee-inputs-gender col-md-6">
//                     <label htmlFor="" className="label-manaegement-section">
//                       User Role
//                     </label>
//                     <Select
//                       classNamePrefix="prefix-department"
//                       placeholder="Please Select User Role"
//                       options={userRoleData}
//                       getOptionLabel={(options) => options?.RoleName}
//                       getOptionValue={(options) => options?.Id}
//                       onChange={handleUserRole}
//                       value={addEmloyee?.UserRole}
//                     />
//                     {userRoleError === "userRole" && !finalUserRole ? (
//                       <span className="contact_error-Addemployee">
//                         User Role is required.
//                       </span>
//                     ) : null}
//                   </div>
//                   {addEmloyee?.UserRole?.RoleName !== "Admin" &&
//                   addEmloyee?.UserRole?.Id ? (
//                     <>
//                       <div className="Addemployee-inputs-department col-md-4">
//                         <label htmlFor="" className="label-manaegement-section">
//                           Department
//                         </label>
//                         <Select
//                           classNamePrefix="prefix-department"
//                           placeholder="Please Select Department"
//                           options={departmentData}
//                           getOptionLabel={(options) => options?.label}
//                           getOptionValue={(options) => options?.value}
//                           // value={addEmloyee?.Department}
//                           value={
//                             addEmloyee?.UserRole?.RoleName === "HR"
//                               ? departmentData.find(
//                                   (department) =>
//                                     department.label === "Management"
//                                 )
//                               : addEmloyee?.Department
//                           }
//                           onChange={handleDepartmentChange}
//                         />
//                         {departmentError === "department" && !departmentId ? (
//                           <span className="validation-error-addemployee">
//                             * Please Select department.
//                           </span>
//                         ) : null}
//                       </div>
//                     </>
//                   ) : null}

//                   {DesignationData && DesignationData?.length ? (
//                     <div className="Addemployee-inputs-department-optional col-md-4">
//                       <label htmlFor="" className="label-manaegement-section">
//                         Sub Department
//                       </label>
//                       <Select
//                         classNamePrefix="subdepartment-dropdown"
//                         placeholder="Please Select Sub Department"
//                         options={DesignationData}
//                         getOptionLabel={(options) => options?.DesignationName}
//                         getOptionValue={(options) => options?.Id}
//                         onChange={handleDesignationData}
//                         value={addEmloyee?.Designation}
//                       />

//                       {designationDepartmentError ===
//                         "userDepartmentDesignation" && !designationId ? (
//                         <span className="contact_error-Addemployee">
//                           * Please Select Sub Department.
//                         </span>
//                       ) : null}
//                     </div>
//                   ) : null}

//                   {teamLeadData?.length &&
//                   addEmloyee?.UserRole?.RoleName !== "TeamLead" &&
//                   addEmloyee?.UserRole?.RoleName !== "HR" ? (
//                     <div className="Addemployee-inputs-department-optional col-md-4">
//                       <label htmlFor="" className="label-manaegement-section">
//                         Team Lead
//                       </label>
//                       <Select
//                         classNamePrefix="subdepartment-dropdown"
//                         placeholder="Please Select Team Lead"
//                         options={teamLeadData}
//                         getOptionLabel={(options) => options?.FirstName}
//                         getOptionValue={(options) => options?.Id}
//                         onChange={handleTeamLeadData}
//                         value={addEmloyee?.TeamLead}
//                       />

//                       {teamLeadDepartMentError === "userDepartmentTeamLead" &&
//                       !isFinalTeamLeadData ? (
//                         <span className="contact_error-Addemployee">
//                           * Please Select Team Lead.
//                         </span>
//                       ) : null}
//                     </div>
//                   ) : null}

//                   <div>
//                     <label htmlFor="" className="upload-image-add-employee">
//                       Image
//                     </label>
//                     <div className="Addemployee-input-file col-md12">
//                       <input
//                         className="Addemployee-file-input"
//                         id="fileInput"
//                         type="file"
//                         ref={fileInputRef}
//                         onChange={handleFileChange}
//                       />
//                     </div>
//                     {uploadImageError === "useruploadImage" &&
//                     !addEmloyee?.UploardImage ? (
//                       <span className="contact_error-dob">
//                         Image is required
//                       </span>
//                     ) : null}
//                   </div>
//                   <div className="Addemployee-buttons">
//                     <button
//                       className="Addemployee-submit-button"
//                       onClick={() => handleAddEmployee()}
//                     >
//                       Submit
//                     </button>
//                     <button onClick={handleEmptyInputData} className="Addemployee-Cancel-button">
//                       Cancel
//                     </button>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </section>
//       </div>
//     </>
//   );
// };
// export default AddEmployee;

import React, { useEffect, useRef, useState } from "react";
import { MdKeyboardArrowRight } from "react-icons/md";
import { BiHomeAlt } from "react-icons/bi";
import "../AddEmployee/AddEmployee.css";
import Select from "react-select";
import { Apiurl, GetToken, Token, userId } from "../../../Utils/utils";
import axios from "axios";
import { toast } from "react-toastify";
import FloatingLabelInput from "../../../Components/floatingLabel/FloatingLabel";
import Header from "../../../Components/Dashboard/Header/Header";
import Sidebar from "../../../Components/Dashboard/Sidebar/Sidebar";
import { useLocation, useNavigate } from "react-router-dom";
import moment from "moment";
import Loader from "../../../Components/loader/loader";

const AddEmployee = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const comingData = location.state;

  const [addEmloyee, setAddEmloyee] = useState({
    Name: "",
    LastName: "",
    Address: "",
    Email: "",
    Phone: "",
    EmergencyContact: "",
    Gender: "",
    DateOfBirth: "",
    DateOfJoining: "",
    DateOfLeaving: "",
    Department: "",
    Designation: "",
    TeamLead: "",
    UserRole: "",
    UploardImage: "",
    Password: "",
    ImageExtension: "",
    ImageName: "",
  });
  console.log(addEmloyee,"addEmloyee");
  const [departmentData, setDepartmentData] = useState([]);
  const [saveDesignationOfDepartment, setSaveDesignationOfDepartment] =
    useState("");
  const [teamLeadData, setTeamLeadData] = useState([]);
  const [isFinalTeamLeadData, setIsFinalTeamLeadData] = useState("");
  const [DesignationData, setDesignationData] = useState([]);
  const [filterTeamValue, setFilterTeamValue] = useState();
  const [userRoleData, setUserRoleData] = useState([]);
  const currentDate = new Date().toISOString().split("T")[0];
  const [showSidebar, setShowSidebar] = useState(true);
  const fileInputRef = useRef(null);
  const [departmentId, setDepartmentId] = useState("");
  const [designationId, setDesignationId] = useState("");
  const handleDepartmentChange = (selectedOption) => {
    setDepartmentId(selectedOption?.value);
    setAddEmloyee({ ...addEmloyee, Department: selectedOption , Designation:"", TeamLead:""});
  };
  const handleDesignationData = (selectedOption) => {
    setAddEmloyee({ ...addEmloyee, Designation: selectedOption, TeamLead:"" });
    setSaveDesignationOfDepartment(selectedOption);
    setDesignationId(selectedOption?.Id);
  };
  const [finalUserRole, setFinalUserRole] = useState();
  const [userRoleError, setUserRoleError] = useState();
  const handleTeamLeadData = (e) => {
    setIsFinalTeamLeadData(e);
    setAddEmloyee({ ...addEmloyee, TeamLead: e });
  };
  const handleUserRole = (e) => {
    setFinalUserRole(e);
    setAddEmloyee({ ...addEmloyee, UserRole: e, Department: "" });
    setDesignationData([]);
  };

  useEffect(() => {
    if (teamLeadData) {
      const filter = teamLeadData?.filter(
        (i) => i?.UserId === comingData?.TeamLead
      );
      setFilterTeamValue(filter);
      setAddEmloyee({ ...addEmloyee, TeamLead: filter?.[0] });
    }
  }, [teamLeadData]);
  const DateOfBirth = (e) => {
    const selectedDate = e.target.value;
    const today = new Date();
    const birthDate = new Date(selectedDate);
    const age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();
    if (
      age < 18 ||
      (age === 18 &&
        (monthDiff > 0 ||
          (monthDiff === 0 && today.getDate() < birthDate.getDate())))
    ) {
      setAddEmloyee({
        ...addEmloyee,
        DateOfBirth: "",
      });
    } else {
      setAddEmloyee({
        ...addEmloyee,
        DateOfBirth: selectedDate,
      });
    }
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        const base64Image = reader.result;
        const exactBase64 = base64Image.split(",")[1];
        const fileExtension = file.name.split(".").pop().toLowerCase();

        setAddEmloyee({
          ...addEmloyee,
          UploardImage: exactBase64,
          ImageExtension: fileExtension,
          ImageName: file,
        });
      };
      reader.readAsDataURL(file);
    }
  };
  useEffect(() => {
    if (window.innerWidth < 600) {
      const timeoutId = setTimeout(() => {
        setShowSidebar(false);
      }, 1000);
      return () => clearTimeout(timeoutId);
    }
    setShowSidebar(true);
  }, []);
  const Gender = [
    { value: "Male", label: "Male", id: 0 },
    { value: "Female", label: "Female", id: 1 },
    // { value: "Transgender", label: "Transgender", id: 2 },
  ];
  const ComingEditDob = moment(comingData?.DateOfBirth).format("YYYY-MM-DD");

  const ComingEditDateOfJoining = moment(comingData?.DateofJoining).format(
    "YYYY-MM-DD"
  );


  const ComingEditDateOfLeaving = comingData?.DateOfLeaving
    ? moment(comingData?.DateOfLeaving).format("YYYY-MM-DD")
    : " ";
  const ComingGender = Gender?.filter((i) => i?.id === comingData?.Gender);

  // const ComingDesignation = DesignationData?.filter(
  //   (e) => e?.value === comingData?.Department
  // );
  const SUBDesignation = DesignationData?.find((e) => {
    return e.DesignationName === comingData?.Designations?.DesignationName;
  });

  const ComingDepartment = departmentData?.filter(
    (e) => e?.value === comingData?.Department
  );

  const ComingRole = userRoleData?.filter(
    (e) => e?.Id === comingData?.Position
  );



  useEffect(() => {
    if (comingData) {
      const TeamLeadArray = [...teamLeadData];
      const filteredTeamLead = TeamLeadArray?.filter(
        (e) => e.UserId === comingData?.TeamLead
      );
      setAddEmloyee({
        Name: comingData?.FirstName,
        LastName: comingData?.LastName,
        Email: comingData?.Email,
        Address: comingData?.Address,
        Phone: comingData?.Mobile,
        EmergencyContact: comingData?.Emergencycontactno,
        Gender: ComingGender,
        DateOfBirth: ComingEditDob,
        DateOfJoining: ComingEditDateOfJoining,
        DateOfLeaving: ComingEditDateOfLeaving || "",
        Department: comingData?.Departments,
        Position: comingData?.Position,
        // Designation: comingData?.Designations,
        Designation: comingData?.Designations,
        // DesignationName: SUBDesignation,
        UserRole: comingData?.Positions,
        // TeamLead: TeamLead,
        TeamLead: filteredTeamLead || null,
      });
      const userRole = ComingRole?.[0] || "";
      setFinalUserRole(userRole);
      setDepartmentId(comingData?.Designations?.Id);
    }
  }, [comingData]);

  const [errorName, setErrorName] = useState(false);
  const [errorLastName, setErrorLastName] = useState(false);
  const [errorAddress, setErrorAddress] = useState(false);
  const [errorEmail, setErrorEmail] = useState(false);
  const [errorPhone, setErrorPhone] = useState(false);
  const [errorEmergencyContact, setErrorEmergencyContact] = useState(false);
  const [errorDateOfBirth, setErrorDateOfBirth] = useState(false);
  const [errorDateOfJoining, setErrorDateOfJoining] = useState(false);
  const [errorDateofLeaving, setErrorDateOfLeaving] = useState(false);
  const [errorGender, setErrorGender] = useState(false);
  const [departmentError, setDepartmentError] = useState(false);
  const [designationDepartmentError, setDesignationDepartmentError] =
    useState(false);
  const [teamLeadDepartMentError, setTeamLeadDepartMentError] = useState(false);
  const [uploadImageError, setUploadImageError] = useState(false);
  const [errorPassword, setErrorPassword] = useState(false);
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  function isValidEmail(Email) {
    return emailRegex.test(Email);
  }

  const validate = () => {
    if (!addEmloyee?.Name) {
      setErrorName("usernamedata");
      return false;
    }
    if (!addEmloyee?.LastName) {
      setErrorLastName("userLastnamedata");
      return false;
    }

    if (!addEmloyee?.Email) {
      setErrorEmail("userEmail");
      return false;
    }

    if (!isValidEmail(addEmloyee?.Email)) {
      toast.error("Please enter valid email");
      return false;
    }
    if (!addEmloyee?.Address) {
      setErrorAddress("userAddress");
      return false;
    }

    if (!addEmloyee?.Phone) {
      setErrorPhone("userPhone");
      return false;
    }
    // if (addEmloyee?.Phone?.length < 10) {
    //   toast.error("Please enter correct number");
    //   return false;
    // }

    if (!addEmloyee?.EmergencyContact) {
      setErrorEmergencyContact("userEmergencyContact");
      return false;
    }
    // if (addEmloyee?.EmergencyContact?.length < 10) {
    //   toast.error("Please enter correct number");
    //   return false;
    // }
    if (!addEmloyee?.Password) {
      setErrorPassword("password");
      return false;
    }

    if (!addEmloyee?.DateOfBirth) {
      setErrorDateOfBirth("userDateOfBirth");
      return false;
    }
    if (!addEmloyee?.DateOfJoining) {
      setErrorDateOfJoining("userDateOfJoining");
      return false;
    }
    // if (!addEmloyee?.DateOfLeaving) {
    //   setErrorDateOfLeaving("userDateofLeaving");
    //   return false;
    // }
    if (!addEmloyee?.Gender) {
      setErrorGender("userGender");
      return false;
    }
    if (!addEmloyee.UserRole) {
      setUserRoleError("userRole");
      return false;
    }

    if (!addEmloyee.Department) {
      setDepartmentError("department");
      return false;
    }
    // if (!addEmloyee.Designation) {
    //   setDesignationDepartmentError("userDepartmentDesignation");
    //   return false;
    // }
    if (teamLeadData?.length && !addEmloyee?.TeamLead) {
      setTeamLeadDepartMentError("userDepartmentTeamLead");
      return false;
    }
    if (!addEmloyee?.UploardImage) {
      setUploadImageError("useruploadImage");
      return false;
    }
    return true;
  };

  //  SaveEmployee Api
  const handleAddEmployee = (e) => {
    // if (!validate()) return;

    e?.preventDefault();
    setLoading(true);
    const LoginToken = GetToken();

    const data = {};
    if (comingData) {
      data.Id = comingData?.Id;
    }
    data.FirstName = addEmloyee?.Name;
    data.LastName = addEmloyee?.LastName;
    // data.Designation = designationId;
    data.Designation = addEmloyee.Designation.Id;
    data.Address = addEmloyee?.Address;
    data.Email = addEmloyee?.Email;
    data.Mobile = addEmloyee?.Phone;
    data.Emergencycontactno = addEmloyee?.EmergencyContact;
    data.DateOfBirth = addEmloyee?.DateOfBirth;
    data.DateOfJoining = addEmloyee?.DateOfJoining;
    data.DateofLeaving = null;
    // data.Department = departmentId;Department
    data.Department = addEmloyee.Department?.value || addEmloyee?.Department?.Id;
    data.Photo = addEmloyee?.UploardImage;
    data.Gender = addEmloyee?.Gender?.id;
    data.Position = addEmloyee?.UserRole?.Id;
    data.TeamLead =
      filterTeamValue?.[0]?.UserId || addEmloyee?.TeamLead?.UserId;
    data.Password = addEmloyee?.Password;
    data.PhotoExtenssion = addEmloyee?.ImageExtension;

    const option = {
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        authorization: `Bearer ${LoginToken}`,
      },
      url: `${Apiurl()}/Admin/SaveEmployee`,
      data: { data: JSON.stringify(data) },
    };
    axios(option)
      .then((e) => {
        setLoading(false);
        if (e?.status === 200) {
          toast.success(e?.data?.message);
          setAddEmloyee({
            Name: "",
            LastName: "",
            Address: "",
            Email: "",
            Phone: "",
            EmergencyContact: "",
            Gender: "",
            DateOfBirth: "",
            DateOfJoining: "",
            DateOfLeaving: "",
            Department: "",
            Designation: "",
            TeamLead: "",
            UserRole: "",
            UploardImage: "",
            Password: "",
            ImageExtension: "",
          });
          // setDepartmentId("");
          setErrorName("");
          setErrorLastName("");
          setErrorEmail("");
          setErrorAddress("");
          setErrorPhone("");
          setErrorEmergencyContact("");
          setErrorPassword("");
          setErrorDateOfBirth("");
          setErrorDateOfBirth("");
          setErrorDateOfJoining("");
          setErrorDateOfLeaving("");
          setErrorGender("");
          setUserRoleError("");
          setUploadImageError("");
          setDepartmentError("");
          setDesignationDepartmentError("");
          setTeamLeadDepartMentError("");
          fileInputRef.current.value = null;
          if (comingData) {
            navigate("/Adm/Employees/AllEmployees");
          }
        }
      })

      .catch((err) => {
        setLoading(false);
        toast.error(err?.response?.data?.message);
      });
  };

  // Get Departments API
  const getDepartment = () => {
    setLoading(true);
    const token = GetToken();
    const option = {
      method: "GET",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      url: `${Apiurl()}/Admin/GetDepartments`,
    };
    axios(option)
      .then((e) => {
        setLoading(false);
        const data = JSON.parse(e?.data?.data);
        const finalData = data?.map((item) => ({
          label: item?.Name,
          value: item?.Id,
        }));
        setDepartmentData(finalData);
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  useEffect(() => {
    getDepartment();
  }, []);

  // Post GetDesignations api
  const handleDesignations = (e) => {
    // if (!validate()) return;
    e?.preventDefault();
    setLoading(true);
    const LoginToken = GetToken();

    const data = {};
    data.DepartmentId = addEmloyee?.Department?.value || addEmloyee?.Department?.Id ;

    const option = {
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        authorization: `Bearer ${LoginToken}`,
      },
      url: `${Apiurl()}/Admin/GetDesignations`,
      data: { data: JSON.stringify(data) },
    };
    axios(option)
      .then((e) => {
        setLoading(false);
        const data = JSON.parse(e?.data?.data);
        setDesignationData(data);
      })
      .catch((err) => {
        setLoading(false);
        toast.error(err?.response?.data?.message);
      });
  };
  useEffect(() => {
    if (departmentId) {
      setSaveDesignationOfDepartment("");
      setDesignationId("");
      setTeamLeadData("");
      // setAddEmloyee({ ...addEmloyee, Designation: "", TeamLead: "" });
      setIsFinalTeamLeadData("");
      handleDesignations();
    }
  }, [departmentId]);

  // useEffect(()=>{
  //   if (addEmloyee.Department) {
  //     alert("1")
  //     handleDesignations()
  //   }
  // },[addEmloyee])

  // team leads retrieve
  const GetTeamLeads = () => {
    setLoading(true);
    const LoginToken = GetToken();
    const data = {};

    if(saveDesignationOfDepartment?.Id) {
      data.Department = saveDesignationOfDepartment?.Department?.Id;
      data.Designation = saveDesignationOfDepartment?.Id;
    } else {

      data.Department =
        addEmloyee?.Department?.Id;
      data.Designation =
         addEmloyee?.Designation?.Id;
    }
    const option = {
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        authorization: `Bearer ${LoginToken}`,
      },
      url: `${Apiurl()}/Admin/GetTeamleads`,
      data: { data: JSON.stringify(data) },
    };
    axios(option)
      .then((e) => {
        setLoading(false);
        const data = JSON.parse(e?.data?.data);
        setTeamLeadData(data);
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  useEffect(() => {
    if (saveDesignationOfDepartment) {
      setAddEmloyee({ ...addEmloyee, TeamLead: "" });
      setIsFinalTeamLeadData("");
      GetTeamLeads(saveDesignationOfDepartment);
    }
  }, [saveDesignationOfDepartment]);

  useEffect(() => {
    if (addEmloyee.Designation || addEmloyee.Department) {
      GetTeamLeads();
    }
  }, [addEmloyee.Designation,addEmloyee.Department]);

  // user role retrieve
  const GetUserRole = () => {
    setLoading(true);
    const LoginToken = GetToken();
    const option = {
      method: "GET",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        authorization: `Bearer ${LoginToken}`,
      },
      url: `${Apiurl()}/Admin/GetPositions`,
    };
    axios(option)
      .then((e) => {
        setLoading(false);
        const data = JSON.parse(e?.data?.data);
        setUserRoleData(data);
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  useEffect(() => {
    GetUserRole();
  }, []);

  useEffect(() => {
    // Check if UserRole is HR and set default department
    if (addEmloyee?.UserRole?.RoleName === "HR") {
      const defaultDepartment = departmentData.find(
        (department) => department.label === "Management"
      );
      handleDepartmentChange(defaultDepartment);
    }
  }, [addEmloyee?.UserRole]);

  const handleEmptyInputData = () => {
    setAddEmloyee((prevEmployee) => ({
      ...prevEmployee,
      Name: "",
      LastName: "",
      Address: "",
      Email: "",
      Phone: "",
      EmergencyContact: "",
      Gender: "",
      DateOfBirth: "",
      DateOfJoining: "",
      DateOfLeaving: "",
      Department: "",
      Designation: "",
      TeamLead: "",
      UserRole: "",
      UploardImage: "",
      Password: "",
      ImageExtension: "",
      ImageName: "",
    }));
    // setDepartmentId("");
    setErrorName("");
    setErrorLastName("");
    setErrorEmail("");
    setErrorAddress("");
    setErrorPhone("");
    setErrorEmergencyContact("");
    setErrorPassword("");
    setErrorDateOfBirth("");
    setErrorDateOfBirth("");
    setErrorDateOfJoining("");
    setErrorDateOfLeaving("");
    setErrorGender("");
    setUserRoleError("");
    setUploadImageError("");
    setDepartmentError("");
    setDesignationDepartmentError("");
    setTeamLeadDepartMentError("");
    fileInputRef.current.value = null;
  };

  return (
    <>
      {loading ? <Loader /> : null}
      <Header showSidebar={showSidebar} setShowSidebar={setShowSidebar} />
      <div className="d-flex">
        <Sidebar showSidebar={showSidebar} />
        <section
          className={
            showSidebar ? "addEmloyees-section" : "addEmloyees-section-new"
          }
        >
          <div className="addEmloyees-all-icons">
            <div>
              <p className="DASHBOARD-MAIN-HEADING">
                {" "}
                {comingData ? "Update Employee" : " Add Employee"}{" "}
              </p>
            </div>
            <div className="dashboiard-inner-header">
              <BiHomeAlt className="home-icon-header-inn" />
              <MdKeyboardArrowRight />
              <p>Employees </p>
              <MdKeyboardArrowRight />
              <p> {comingData ? "Update Employee" : " Add Employee"} </p>
            </div>
          </div>

          <div className="Addemployee-main-container">
            <div className="Addemployee-outter-container">
              <div className="Addemployee-inner-container">
                <div className="AddEmployee-heading">
                  <p> {comingData ? "Update Employee" : " Add Employee"}</p>
                </div>
                <div className="Addemployee-inner-box row">
                  <div className="Addemployee-inputs col-md-6">
                    <FloatingLabelInput
                      label="First Name*"
                      value={addEmloyee?.Name}
                      onChange={(e) =>
                        setAddEmloyee({
                          ...addEmloyee,
                          Name: e?.target?.value,
                        })
                      }
                      onBlur={(e) => {
                        if (!e?.target?.value) {
                          setErrorName("usernamedata");
                        } else {
                          setErrorName("false");
                        }
                      }}
                    />
                    {errorName === "usernamedata" && !addEmloyee?.Name ? (
                      <span className="contact_error-Addemployee">
                        First Name is required.
                      </span>
                    ) : null}
                  </div>

                  <div className="Addemployee-inputs col-md-6">
                    <FloatingLabelInput
                      label="Last Name*"
                      value={addEmloyee?.LastName}
                      onChange={(e) =>
                        setAddEmloyee({
                          ...addEmloyee,
                          LastName: e?.target?.value,
                        })
                      }
                      onBlur={(e) => {
                        if (!e?.target?.value) {
                          setErrorLastName("userLastnamedata");
                        } else {
                          setErrorLastName("false");
                        }
                      }}
                    />
                    {errorLastName === "userLastnamedata" &&
                    !addEmloyee?.LastName ? (
                      <span className="contact_error-Addemployee">
                        Last Name is required.
                      </span>
                    ) : null}
                  </div>

                  <div className="Addemployee-inputs col-md-6">
                    <FloatingLabelInput
                      label="Email*"
                      value={addEmloyee?.Email}
                      onChange={(e) =>
                        setAddEmloyee({
                          ...addEmloyee,
                          Email: e?.target?.value,
                        })
                      }
                      onBlur={(e) => {
                        if (!e?.target?.value) {
                          setErrorEmail("userEmail");
                        } else {
                          setErrorEmail("false");
                        }
                      }}
                    />
                    {errorEmail === "userEmail" && !addEmloyee?.Email ? (
                      <span className="contact_error-Addemployee">
                        Email is required.
                      </span>
                    ) : null}
                  </div>
                  <div className="Addemployee-inputs col-md-6">
                    <FloatingLabelInput
                      label="Address*"
                      value={addEmloyee?.Address}
                      onChange={(e) =>
                        setAddEmloyee({
                          ...addEmloyee,
                          Address: e?.target?.value,
                        })
                      }
                      onBlur={(e) => {
                        if (!e?.target?.value) {
                          setErrorAddress("userAddress");
                        } else {
                          setErrorAddress("false");
                        }
                      }}
                    />
                    {errorAddress === "userAddress" && !addEmloyee?.Address ? (
                      <span className="contact_error-Addemployee">
                        Address is required.
                      </span>
                    ) : null}
                  </div>
                  <div className="Addemployee-inputs col-md-4">
                    <FloatingLabelInput
                      type="tel"
                      label="Phone No*"
                      maxLength="10"
                      value={addEmloyee?.Phone}
                      onChange={(e) => {
                        const inputMobile = e.target.value
                          .replace(/\D/g, "")
                          .slice(0, 10);
                        setAddEmloyee({
                          ...addEmloyee,
                          Phone: inputMobile,
                        });
                      }}
                      // onChange={(e) =>
                      //   setAddEmloyee({
                      //     ...addEmloyee,
                      //     Phone: e?.target?.value,
                      //   })
                      // }
                      onBlur={(e) => {
                        if (!e?.target?.value) {
                          setErrorPhone("userPhone");
                        } else {
                          setErrorPhone("false");
                        }
                      }}
                    />
                    {errorPhone === "userPhone" && !addEmloyee?.Phone ? (
                      <span className="contact_error-Addemployee">
                        Phone Number is required.
                      </span>
                    ) : null}
                  </div>
                  <div className="Addemployee-inputs col-md-4">
                    <FloatingLabelInput
                      type="tel"
                      maxLength="10"
                      label="Emergency Contact No.*"
                      value={addEmloyee?.EmergencyContact}
                      onChange={(e) => {
                        const inputMobile = e.target.value
                          .replace(/\D/g, "")
                          .slice(0, 10);
                        setAddEmloyee({
                          ...addEmloyee,
                          EmergencyContact: inputMobile,
                        });
                      }}
                      // onChange={(e) =>
                      //   setAddEmloyee({
                      //     ...addEmloyee,
                      //     EmergencyContact: e?.target?.value,
                      //   })
                      // }
                      onBlur={(e) => {
                        if (!e?.target?.value) {
                          setErrorEmergencyContact("userEmergencyContact");
                        } else {
                          setErrorEmergencyContact("false");
                        }
                      }}
                    />
                    {errorEmergencyContact === "userEmergencyContact" &&
                    !addEmloyee?.EmergencyContact ? (
                      <span className="contact_error-Addemployee">
                        Emergency Contact Number is required.
                      </span>
                    ) : null}
                  </div>

                  <div className="Addemployee-inputs col-md-4">
                    <FloatingLabelInput
                      type="password"
                      label="Password*"
                      value={addEmloyee?.Password}
                      onChange={(e) =>
                        setAddEmloyee({
                          ...addEmloyee,
                          Password: e?.target?.value,
                        })
                      }
                      onBlur={(e) => {
                        if (!e?.target?.value) {
                          setErrorPassword("password");
                        } else {
                          setErrorPassword("false");
                        }
                      }}
                    />
                    {errorPassword === "password" && !addEmloyee?.Password ? (
                      <span className="contact_error-Addemployee">
                        Password is required.
                      </span>
                    ) : null}
                  </div>

                  <div className="Addemployee-inputs-cal col-md-4   ">
                    <label htmlFor="DateOfBirth">Date of Birth </label>
                    <input
                      type="date"
                      name="DateOfBirth"
                      id="DateOfBirth"
                      value={addEmloyee?.DateOfBirth}
                      onChange={DateOfBirth}
                      max={moment().subtract(18, "years").format("YYYY-MM-DD")}
                    />
                    {errorDateOfBirth === "userDateOfBirth" &&
                    !addEmloyee?.DateOfBirth ? (
                      <span className="contact_error-dob">
                        Date Of Birth is required.
                      </span>
                    ) : null}
                  </div>
                  <div className="Addemployee-inputs-cal col-md-4">
                    <label htmlFor="">Date of Joining</label>
                    <input
                      type="date"
                      name=""
                      id=""
                      value={addEmloyee?.DateOfJoining}
                      onChange={(e) =>
                        setAddEmloyee({
                          ...addEmloyee,
                          DateOfJoining: e?.target?.value,
                        })
                      }
                      max={currentDate}
                    />

                    {errorDateOfJoining === "userDateOfJoining" &&
                    !addEmloyee?.DateOfJoining ? (
                      <span className="contact_error-dob">
                        Date Of Joining is required.
                      </span>
                    ) : null}
                  </div>
                  <div className="Addemployee-inputs-cal col-md-4">
                    <label htmlFor="">Date of Leaving</label>
                    <input
                      type="date"
                      value={addEmloyee?.DateOfLeaving}
                      onChange={(e) =>
                        setAddEmloyee({
                          ...addEmloyee,
                          DateOfLeaving: e?.target?.value,
                        })
                      }
                      max={currentDate}
                    />
                  </div>
                  {/* {errorDateofLeaving === "userDateofLeaving" &&
                    !addEmloyee?.DateOfLeaving ? (
                      <span className="contact_error-dob">
                        Date Of Joining is required.
                      </span>
                    ) : null} */}

                  <div className="Addemployee-inputs-gender col-md-6">
                    <label htmlFor="" className="label-manaegement-section">
                      Gender
                    </label>
                    <Select
                      //   className="Department-dropdown"
                      classNamePrefix="genderSelect"
                      placeholder="Please Select Gender"
                      options={Gender}
                      value={addEmloyee?.Gender}
                      onChange={(selectedOption) =>
                        setAddEmloyee({
                          ...addEmloyee,
                          Gender: selectedOption,
                        })
                      }
                      onBlur={(e) => {
                        if (!e?.target?.value) {
                          setErrorGender("userGender");
                        } else {
                          setErrorGender("false");
                        }
                      }}
                    />
                    {errorGender === "userGender" && !addEmloyee?.Gender ? (
                      <span className="contact_error-Addemployee">
                        Gender is required.
                      </span>
                    ) : null}
                  </div>

                  <div className="Addemployee-inputs-gender col-md-6">
                    <label htmlFor="" className="label-manaegement-section">
                      User Role
                    </label>
                    <Select
                      classNamePrefix="prefix-department"
                      placeholder="Please Select User Role"
                      options={userRoleData}
                      getOptionLabel={(options) => options?.RoleName}
                      getOptionValue={(options) => options?.Id}
                      onChange={handleUserRole}
                      // value={addEmloyee?.UserRole}
                      value={addEmloyee?.UserRole}
                    />
                    {userRoleError === "userRole" && !finalUserRole ? (
                      <span className="contact_error-Addemployee">
                        User Role is required.
                      </span>
                    ) : null}
                  </div>
                  {addEmloyee?.UserRole?.RoleName !== "Admin" &&
                  addEmloyee?.UserRole?.Id ? (
                    <>
                      <div className="Addemployee-inputs-department col-md-4">
                        <label htmlFor="" className="label-manaegement-section">
                          Department
                        </label>
                        <Select
                          classNamePrefix="prefix-department"
                          placeholder="Please Select Department"
                          options={departmentData}
                          getOptionLabel={(options) => options?.label}
                          getOptionValue={(options) => options?.value}
                          // value={addEmloyee?.Department}
                          value={
                            addEmloyee?.UserRole?.RoleName === "HR"
                              ? departmentData?.find(
                                  (department) =>
                                    department.label === "Management"
                                )
                              : {
                                  value: addEmloyee?.Department?.Id
                                    ? addEmloyee?.Department?.Id
                                    : addEmloyee?.Department?.value,
                                  label: addEmloyee?.Department?.Name
                                    ? addEmloyee?.Department?.Name
                                    : addEmloyee?.Department?.label,
                                }
                          }
                          onChange={handleDepartmentChange}
                        />
                        {departmentError === "department" && !departmentId ? (
                          <span className="validation-error-addemployee">
                            * Please Select department.
                          </span>
                        ) : null}
                      </div>
                    </>
                  ) : null}
              


                  {addEmloyee?.Department  && addEmloyee?.Department.label !== "Sales/Marketing" ? (
                    <div className="Addemployee-inputs-department-optional col-md-4">
                      
                      <label htmlFor="" className="label-manaegement-section">
                        Sub Department
                      </label>
                      <Select
                        classNamePrefix="subdepartment-dropdown"
                        placeholder="Please Select Sub Department"
                        options={DesignationData}
                        getOptionLabel={(options) => options?.DesignationName}
                        getOptionValue={(options) => options?.Id}
                        onChange={handleDesignationData}
                        value={addEmloyee?.Designation}
                      />

                      {designationDepartmentError ===
                        "userDepartmentDesignation" && !designationId ? (
                        <span className="contact_error-Addemployee">
                          * Please Select Sub Department.
                        </span>
                      ) : null}
                    </div>
                  ) : null}

                  {addEmloyee?.Designation &&
                  addEmloyee?.UserRole?.RoleName !== "TeamLead" &&
                  addEmloyee?.UserRole?.RoleName !== "HR" || addEmloyee.Department.label === "Sales/Marketing"  ?  (
                    <div className="Addemployee-inputs-department-optional col-md-4">
                      <label htmlFor="" className="label-manaegement-section">
                        Team Lead
                      </label>
                      <Select
                        classNamePrefix="subdepartment-dropdown"
                        placeholder="Please Select Team Lead"
                        options={teamLeadData}
                        getOptionLabel={(options) => options?.FirstName}
                        getOptionValue={(options) => options?.Id}
                        onChange={handleTeamLeadData}
                        value={addEmloyee?.TeamLead}
                      />

                      {teamLeadDepartMentError === "userDepartmentTeamLead" &&
                      !addEmloyee?.TeamLead ? (
                        <span className="contact_error-Addemployee">
                          * Please Select Team Lead.
                        </span>
                      ) : null}
                    </div>
                  ) : null}

                  <div>
                    <label htmlFor="" className="upload-image-add-employee">
                      Image
                    </label>
                    <div className="Addemployee-input-file col-md12">
                      <input
                        className="Addemployee-file-input"
                        id="fileInput"
                        type="file"
                        ref={fileInputRef}
                        onChange={handleFileChange}
                      />
                    </div>
                    {uploadImageError === "useruploadImage" &&
                    !addEmloyee?.UploardImage ? (
                      <span className="contact_error-dob">
                        Image is required
                      </span>
                    ) : null}
                  </div>
                  <div className="Addemployee-buttons">
                    <button
                      className="Addemployee-submit-button"
                      onClick={() => handleAddEmployee()}
                    >
                      {comingData ? "Update" : "Submit"}
                    </button>
                    <button
                      onClick={handleEmptyInputData}
                      className="Addemployee-Cancel-button"
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};
export default AddEmployee;
